"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MySpinner = MySpinner;
exports.Header = Header;
exports.NotFound = NotFound;

var _react = _interopRequireDefault(require("react"));

var _reactBootstrap = require("react-bootstrap");

var _hookrouter = require("hookrouter");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function MySpinner() {
  return _react["default"].createElement("div", {
    className: "container vh-100"
  }, _react["default"].createElement("div", {
    className: "d-flex align-items-center justify-content-center h-100"
  }, _react["default"].createElement(_reactBootstrap.Spinner, {
    animation: "border",
    role: "status"
  }, _react["default"].createElement("span", {
    className: "sr-only"
  }, "Loading..."))));
}

function Header(props) {
  var AuthOptions = CommonAuthOptions;

  if (props.customAuthOptions) {
    AuthOptions = props.customAuthOptions;
  }

  return _react["default"].createElement(_reactBootstrap.Navbar, {
    expand: "lg",
    bg: "dark",
    variant: "dark",
    collapseOnSelect: "true"
  }, _react["default"].createElement(_reactBootstrap.Navbar.Brand, null, props.children), _react["default"].createElement(_reactBootstrap.Navbar.Toggle, {
    "aria-controls": "basic-navbar-nav"
  }), _react["default"].createElement(_reactBootstrap.Navbar.Collapse, {
    id: "basic-navbar-nav"
  }, _react["default"].createElement(_reactBootstrap.Nav, {
    className: "ml-auto"
  }, _react["default"].createElement(_reactBootstrap.Nav.Item, null, _react["default"].createElement(_hookrouter.A, {
    href: "/about",
    className: "nav-link"
  }, "About")), _react["default"].createElement(AuthOptions, {
    isAuthenticated: props.isAuthenticated
  }), props.navItems.map(function (navItem, i) {
    return _react["default"].createElement(_reactBootstrap.Nav.Item, null, _react["default"].createElement(_hookrouter.A, {
      href: navItem.href,
      className: "nav-link"
    }, navItem.text));
  }))));
}

function CommonAuthOptions(props) {
  var host = window.location.protocol + "//" + window.location.host;

  if (props.isAuthenticated) {
    return _react["default"].createElement(_reactBootstrap.Nav.Item, null, _react["default"].createElement("a", {
      href: process.env.REACT_APP_AUTH_LOGOUT_URL + "?redirect_url=" + host,
      className: "nav-link"
    }, "Logout"));
  } else {
    return [_react["default"].createElement(_reactBootstrap.Nav.Item, null, _react["default"].createElement("a", {
      href: process.env.REACT_APP_AUTH_LOGIN_URL + "?redirect_url=" + host,
      className: "nav-link"
    }, "Login")), _react["default"].createElement(_reactBootstrap.Nav.Item, null, _react["default"].createElement("a", {
      href: process.env.REACT_APP_AUTH_REGISTER_URL,
      className: "nav-link"
    }, "Register"))];
  }
}

function NotFound() {
  return _react["default"].createElement(_reactBootstrap.Container, {
    className: "vh-100"
  }, _react["default"].createElement("div", {
    className: "jumbotron d-flex align-items-center justify-content-center h-100"
  }, _react["default"].createElement("h2", null, "Oops, looks like that page is not available.")));
}